import React, { useEffect, useState, useContext } from 'react';
import './dashboard.css';
import {getDashboard} from '../../axios';
import authContext from '../../AuthContext';

const Dashboard = () => {
  const { user } = useContext(authContext);
  const [data, setData] = useState({
    batch_count: 0,
    student_count: 0,
  });

  useEffect(() => {
  const fetchData=async()=>{
    const res=await getDashboard(user)
    //console.log(res)
    setData(res.data[0])
  }
  fetchData()
  }, [user]);

  return (
    <div className="dashboard-container">
      <header className="dashboard-header fade-in">Dashboard</header>
      <div className="card-container">
        <div className="card total-batches">
          <h2>Total Batches</h2>
          <p>{data.batch_count !== undefined ? data.batch_count : 'Loading...'}</p>
        </div>
        <div className="card total-students">
          <h2>Total Students</h2>
          <p>{data.student_count !== undefined ? data.student_count : 'Loading...'}</p>
        </div>
        <div className="card pending-batches">
          <h2>Pending Batches</h2>
          <p>0</p> {/* Replace with dynamic data as needed */}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
